import React, { useState } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/fp/get'
import getOr from 'lodash/fp/getOr'
import Modal from 'components/ui/Modal'
import Input from 'components/ui/forms/Input'
import AvatarPicker from 'components/ui/forms/AvatarPicker'

const KidsModal = ({ kid, setShow, callbacks: { add, edit, remove } }) => {
  const [name, setName] = useState(getOr('', 'name', kid))
  const [points, setPoints] = useState(getOr(0, 'balance', kid))
  const [avatar, setAvatar] = useState(get('avatar', kid))
  const title = get('name', kid) ? 'Edit' : 'Add'

  // TODO: prevent save if form is incomplete

  const onModalCallback = (submitted) => {
    if (!submitted) return

    kid && kid.id
      ? edit({ id: kid.id, name, balance: points, avatar })
      : add({ name, balance: points, avatar })
  }

  return (
    <Modal title={title} setShow={setShow} btnTxtSubmit="Save" callback={onModalCallback}>
      <Input label="Name" value={name} onChange={setName} />
      <Input label="Points" value={points} onChange={setPoints} />
      <AvatarPicker label="Avatar" value={avatar} onChange={setAvatar} />
      <div className="h-2" />
      {kid && kid.id && (
        <button
          className="absolute text-sm text-gray-300 bottom-12 hover:underline hover:text-red-600"
          onClick={() => remove(kid.id)}
        >
          Delete
        </button>
      )}
    </Modal>
  )
}

KidsModal.propTypes = {
  kid: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    balance: PropTypes.number,
    avatar: PropTypes.string,
  }),
  callbacks: PropTypes.shape({
    add: PropTypes.func,
    edit: PropTypes.func,
    remove: PropTypes.func,
  }),
}

export default KidsModal
